module.exports = __webpack_public_path__ + "img/pega_azulejos.f535bf4c.png";